module.exports = __webpack_public_path__ + "static/media/starPlayLogoCopy@3x.3bbe7313.png";